module.exports = __webpack_public_path__ + "static/media/mini_map.dcd3451a.jpg";